require('orestbida/cookieconsent/dist/cookieconsent');

window.cookieconsent = initCookieConsent();

var language = document.documentElement?.lang.split('-')[0] || 'de';

var buttonLabel = 'Cookie-Einstellungen anzeigen';
if (language === 'en') {
  buttonLabel = 'Show cookie settings';
}
document.body.innerHTML = document.body.innerHTML.replace('###COOKIE-SETTINGS###', '<button type="button" class="btn-primary" data-cc="c-settings">' + buttonLabel + '</button>');

window.cookieconsent.run({
  current_lang: language,
  force_consent: true,
  gui_options: {
    consent_modal: {
      layout: 'box', // box/cloud/bar
      position: 'middle center', // bottom/middle/top + left/right/center
      transition: 'slide', // zoom/slide
    },
    settings_modal: {
      layout: 'box', // box/bar
      position: 'right', // left/right
      transition: 'slide', // zoom/slide
    },
  },

  page_scripts: true,
  onAccept: function (cookie) {
    window.dataLayer = window.dataLayer || [];
    for (let i = 0; i < cookie.categories.length; i++) {
      const category = cookie.categories[i];
      if (category !== 'necessary') {
        window.dataLayer.push({
          event: 'enable-' + category,
        });
      }
    }
  },
  onChange: function (cookie, changed_categories) {
    window.dataLayer = window.dataLayer || [];
    for (let i = 0; i < changed_categories.length; i++) {
      const category = changed_categories[i];
      if (category !== 'necessary' && cookie.categories.includes(category)) {
        window.dataLayer.push({
          event: 'enable-' + category,
        });
      } else {
        window.dataLayer.push({
          event: 'disable-' + category,
        });
      }
    }
  },

  languages: {
    de: {
      consent_modal: {
        title: 'Cookies',
        description:
          'Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern, personalisierte Werbung oder Inhalte zu präsentieren und unseren Datenverkehr zu analysieren. <br /><br />Weitere Informationen zu Cookies erhalten Sie in diesem Cookiebanner und in unserer Datenschutzerklärung (siehe unten). Klicken Sie auf "Alle Cookies erlauben", um alle Arten von Cookies zu akzeptieren oder klicken Sie auf "Einstellung übernehmen" um nur jene Cookies zu zulassen, die Sie ausgewählt haben. <a href="https://www.samsondruck.at/datenschutz">Zur Datenschutzerklärung.</a>',
        primary_btn: {
          text: 'Alle Cookies erlauben',
          role: 'accept_all', //'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Details anzeigen',
          role: 'settings', //'settings' or 'accept_necessary'
        },
      },
      settings_modal: {
        title: 'Cookie Einstellungen',
        save_settings_btn: 'Einstellung übernehmen',
        accept_all_btn: 'Alle akzeptieren',
        reject_all_btn: 'Alle ablehnen',
        close_btn_label: 'Schließen',
        blocks: [
          {
            title: 'Über Cookies',
            description:
              'Cookies sind kleine Textdateien, die beim Besuch einer Webseite mit Hilfe Ihres Browsers auf Ihrem Rechner, Tablet-Computer oder Smartphone abgelegt werden. Diese Dateien richten keinerlei Schaden an und dienen lediglich der Wiedererkennung des Webseiten-Besuchers. Bei Ihrem nächsten Aufruf der Webseite mit demselben Endgerät können die in Cookies gespeicherten Informationen in weiterer Folge entweder an die Webseite („First Party Cookie“) oder an eine andere Webseite, zu der das Cookie gehört („Third Party Cookie“), zurückgesandt werden.<br><br>Sie können Ihren Browser so einstellen, dass das Speichern von Cookies generell verhindert wird bzw. Sie jedesmal gefragt werden, ob Sie mit dem Setzen von Cookies einverstanden sind. Einmal gesetzte Cookies können Sie jederzeit wieder löschen. Wie das funktioniert, finden Sie in der Hilfe-Funktion Ihres Browsers. Eine Erklärung für die Browser Firefox, Microsoft Internet Explorer und Google Chrome finden Sie unter diesem Link: http://www.meine-cookies.org/cookies_verwalten/index.html.',
          },
          {
            title: 'Erforderlich',
            description:
              'Technisch notwendige Cookies dienen dazu, um den technischen Betrieb einer Webseite zu ermöglichen und diese für Sie funktional nutzbar zu machen. Die Nutzung erfolgt aufgrund unseres berechtigten Interesses eine technisch einwandfreie Webseite anzubieten. Sie können jedoch generell die Cookie Nutzung in Ihrem Browser deaktivieren.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true,
            },
          },
          {
            title: 'Statistik',
            description:
              'Statistik-Cookies sammeln Informationen darüber, wie Webseiten genutzt werden, um folglich deren Attraktivität, Inhalt und Funktionalität zu verbessern. Eine Nutzung erfolgt nur mit Ihrer Einwilligung und zwar nur solange Sie das jeweilige Cookie nicht deaktiviert haben.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false,
            },
          },
          {
            title: 'Marketing',
            description:
              'Marketing-Cookies stammen von externen Werbeunternehmen und werden verwendet, um Informationen über die vom Benutzer besuchten Webseiten zu sammeln. Eine Nutzung erfolgt nur mit Ihrer Einwilligung und zwar nur solange Sie das jeweilige Cookie nicht deaktiviert haben.',
            toggle: {
              value: 'marketing',
              enabled: false,
              readonly: false,
            },
          },
        ],
      },
    },
    en: {
      consent_modal: {
        title: 'Cookies',
        description:
          'We use cookies to enhance your browsing experience, serve personalised ads or content, and analyze our traffic. <br/><br />For more information on cookies, please see this cookie banner and our privacy policy (see below). Click "Allow all cookies" to accept all types of cookies or click "Apply setting" to allow only those cookies you have selected. <a href="https://www.samsondruck.at/datenschutz">Go to Privacy Policy.</a>',
        primary_btn: {
          text: 'Allow all cookies',
          role: 'accept_all', //'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Show details',
          role: 'settings', //'settings' or 'accept_necessary'
        },
      },
      settings_modal: {
        title: 'Cookie settings',
        save_settings_btn: 'Apply setting',
        accept_all_btn: 'Accept all',
        reject_all_btn: 'Decline all',
        close_btn_label: 'Close',
        blocks: [
          {
            title: 'About cookies',
            description:
              'Cookies are small text files that are placed on your computer, tablet computer or smartphone when you visit a website with the help of your browser. These files do not cause any harm and only serve to recognize the website visitor. The next time you call up the website with the same terminal device, the information stored in cookies can subsequently be sent back either to the website ("first party cookie") or to another website to which the cookie belongs ("third party cookie").<br><br>You can set your browser so that the storage of cookies is generally prevented or you are asked each time whether you agree to the setting of cookies. Once cookies have been set, you can delete them at any time. You can find out how this works in the help function of your browser. An explanation for the browsers Firefox, Microsoft Internet Explorer and Google Chrome can be found at this link: http://www.meine-cookies.org/cookies_verwalten/index.html.',
          },
          {
            title: 'Necessary',
            description:
              'Technically necessary cookies are used to enable the technical operation of a website and to make it functionally usable for you. The use is based on our legitimate interest to offer a technically flawless website. However, you can generally deactivate the use of cookies in your browser.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true,
            },
          },
          {
            title: 'Statistics',
            description:
              'Statistics cookies collect information about how websites are used in order to improve their attractiveness, content and functionality. They are only used with your consent and only as long as you have not deactivated the respective cookie.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false,
            },
          },
          {
            title: 'Marketing',
            description:
              'Marketing cookies come from external advertising companies and are used to collect information about the websites visited by the user. They are only used with your consent and only as long as you have not deactivated the respective cookie.',
            toggle: {
              value: 'marketing',
              enabled: false,
              readonly: false,
            },
          },
        ],
      },
    },
  },
});
